/**
 * @file
 * Customization styles for Radar Components.
 */

export const RadarChartStyles = () => {
  return {
   '& .highcharts--radar-chart .to-back': {
     zIndex: -1,
   },
 }
}
